/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_LinkInputs */

const cs_auth_login_link = /** @type {(inputs: Auth_Login_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Již máte účet? Přihlaste se`)
};

const en_auth_login_link = /** @type {(inputs: Auth_Login_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account? Sign in`)
};

/**
* | output |
* | --- |
* | "Already have an account? Sign in" |
*
* @param {Auth_Login_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_login_link = /** @type {((inputs?: Auth_Login_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_login_link(inputs)
	return cs_auth_login_link(inputs)
});